import React from 'react'
import {Select} from '@components/common/base/select'
import {TippyProps} from '@tippyjs/react'

export interface SelectProps {
  isOpen: boolean
  content: React.ReactNode
  onOpenChange: (isOpen: boolean) => void
  children?: React.ReactNode
  disabled?: boolean
  className?: string
  style?: React.CSSProperties
  placeholder?: string
  placement?: TippyProps['placement']
  error?: boolean
  truncate?: boolean
}

export const SharedBaseSelect = (props: SelectProps) => {
  const {
    isOpen,
    content,
    onOpenChange,
    children,
    disabled = false,
    className,
    style,
    placeholder,
    placement,
    error = false,
    truncate = true
  } = props

  return (
    <Select
      content={content}
      open={isOpen}
      onOpenChange={onOpenChange}
      disabled={disabled}
      className={className}
      placeholder={placeholder}
      placement={placement}
      error={error}
      truncate={truncate}
      variant="new"
      selectStyle={style}
    >
      {children}
    </Select>
  )
}
